import { safeDefine } from "../../registration/safe-define.js";
import { BufferingIndicatorElement } from "../../ui/buffering-indicator/element.js";
//#region src/define/ui/buffering-indicator.ts
safeDefine(BufferingIndicatorElement);
//#endregion
